import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'beneficiary-box',
    templateUrl: './beneficiary-box.component.html',
    styleUrls: ['./beneficiary-box.component.scss'],
    standalone: false
})
export class BeneficiaryBoxComponent implements OnInit {
  @Input() title = '';
  @Input() suffix = '';
  @Input() svg = '';
  constructor() {}

  ngOnInit() {}
}
